// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-top {\n  padding-top: 12px;\n  border-top: 1px solid var(--v-secondary-base) !important;\n}", ""]);
// Exports
module.exports = exports;
